import './applied_type_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostSourceView extends Monitoring.Views.SocialContents.Filters.AppliedTypeView

  getAppliedValues: ->
    @searchQuery.get('post_source')

  removeFilter: (value) ->
    @searchQuery.removePostSource(value)
